import { RoomContext } from "App/context";
import React, { useContext } from "react";
import { BalancingBansContext } from "./context";
import BanSelection from "../BanSelection";

type BalancingBansType = {
  badgeQuantity?: number;
  whoBan?: "player1" | "player2";
  soloSide?: "Player 1" | "Player 2";
};

const BalancingBans = (props: BalancingBansType) => {
  const { badgeQuantity = 0, whoBan = "player1", soloSide } = props;
  const { dispatch, selectingBans, selectedBansPlayer1, selectedBansPlayer2 } =
    useContext(BalancingBansContext);

  return (
    <BanSelection
      badgeQuantity={badgeQuantity}
      whoBan={whoBan}
      soloSide={soloSide}
      showEvent="show-balancing-bans"
      clickEvent="on-click-show-balancing-bans"
      selectedEvent="selected-balanced-ban"
      sendEvent="send-balanced-ban"
      buttonText={"Bans d'équilibrage"}
      dispatch={dispatch}
      selectingBans={selectingBans}
      selectedBansPlayer1={selectedBansPlayer1}
      selectedBansPlayer2={selectedBansPlayer2}
      roomUpdate={(room, dispatchRoom) => {
        dispatchRoom({
          balancingBansPlayer1: room.balancingBansPlayer1 ?? undefined,
          balancingBansPlayer2: room.balancingBansPlayer2 ?? undefined,
        });
      }}
      selectedUpdate={(chars, role, dispatch) => {
        if (role === "Player 1") dispatch({ selectedBansPlayer1: chars });
        else dispatch({ selectedBansPlayer2: chars });
      }}
    />
  );
};

export default BalancingBans;
